var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpportunitiesIconTool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.171,
    height: 22.209,
    viewBox: "0 0 22.171 22.209",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H3.22V1H0z",
    transform: "translate(-40 -204.463) translate(-414.709 -14.404) translate(473.66 229.178)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H3.22V1H0z",
    transform: "translate(-40 -204.463) translate(-414.709 -14.404) translate(454.709 229.178)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H3.22V1H0z",
    transform: "translate(-40 -204.463) translate(-414.709 -14.404) rotate(-87.893 348.021 -130.499)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H3.22V1H0z",
    transform: "translate(-40 -204.463) translate(-414.709 -14.404) rotate(-42.9 520.695 -487.674)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H3.22V1H0z",
    transform: "translate(-40 -204.463) translate(-414.709 -14.404) rotate(-42.9 529.906 -463.116)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1V3.22H0z",
    transform: "translate(-40 -204.463) translate(-414.709 -14.404) rotate(-42.9 511.164 -471.395)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1V3.22H0z",
    transform: "translate(-40 -204.463) translate(-414.709 -14.404) rotate(-42.9 535.503 -481.11)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M461.748 235.13h8.082a6.69 6.69 0 1 0-8.082 0z",
    transform: "translate(-40 -204.463) translate(-414.709 -14.404)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.123 236.13v4.037h1.817v.908h3.8v-.908h1.816v-4.037z",
    transform: "translate(-40 -204.463) translate(-414.709 -14.404)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpportunitiesIconTool);
export default __webpack_public_path__ + "static/media/opportunities-icon-tool.aed91307.svg";
export { ForwardRef as ReactComponent };